module.exports = __webpack_public_path__ + "assets/img/1-320x320.400c21b6.webp";